import { DataTransporter } from "../data-transporter";
import { computed, makeObservable, observable } from "mobx";
import _ from "lodash";

export class MunicipalityStore {
    private readonly dataTransporter: DataTransporter;
    private readonly apiUrl: string;
    municipalities: Municipality[];

    constructor(dataTransporter: DataTransporter) {
        this.dataTransporter = dataTransporter;
        this.municipalities = [];
        this.apiUrl = "https://svc.geo.lu.ch/geoshare/rest/services/Hosted/GRZGEMLU_DS_V1_FT/FeatureServer/0/query?where=1=1&returnGeometry=false&outFields=bfs_nr,gemeinde&f=pjson";
    }

    async loadAll(): Promise<Municipality[]> {
        this.municipalities = [];
        const result = await this.dataTransporter.get(this.apiUrl);
        const municipalitiesRaw = result.data.features.map(f => f.attributes);
        const municipalitiesRawUnique = _.uniqBy(municipalitiesRaw, "bfs_nr");
        const municipalityDtos: MunicipalityDto[] = _.sortBy(municipalitiesRawUnique, ["gemeinde"]);
        municipalityDtos.forEach(m => this.municipalities.push(new Municipality(m)));

        return this.municipalities;
    }

    getMunicipality(bfsNr: number): Municipality {
        const municipality = this.municipalities.find(m => m.bfsNr === bfsNr);

        if (municipality !== undefined) {
            return municipality;
        }

        throw new Error("Municipality not found");
    }
}

export class Municipality {
    municipalityDto: MunicipalityDto;

    constructor(municipalityDto: MunicipalityDto) {
        this.municipalityDto = municipalityDto;
        makeObservable(this, {
            municipalityDto: observable,
            bfsNr: computed,
            name: computed
        })
    }

    get bfsNr(): number {
        return this.municipalityDto.bfs_nr;
    }

    get name(): string {
        return this.municipalityDto.gemeinde;
    }
}

export type MunicipalityDto = {
    bfs_nr: number;
    gemeinde: string;
};
